module.exports = __webpack_public_path__ + "img/Ov05-19800618-014.5ea4a0dd.jpg";